/**
 * Address
 * @author Simpli CLI generator
 */

import {$, Helper, Request, Resource} from 'simpli-web-sdk'

/* TODO: review generated class */
export class Address extends Resource {
  idAddressPk: number = 0

  street: string | null = null
  number: string | null = null
  city: string | null = null
  state: string | null = null
  zipcode: string | null = null
  neighborhood: string | null = null

  get $id() {
    return this.idAddressPk
  }
  set $id(val) {
    this.idAddressPk = val
  }
  get $tag() {
    return String(this.$id)
  }

  static stringfied(address: Address): string {
    const {street, city, neighborhood} = address
    let addressStr = ''

    if (street) {
      addressStr += `${street}`
    }
    if (neighborhood) {
      addressStr += `, ${neighborhood}`
    }
    if (city) {
      addressStr += ` / ${city}`
    }

    return addressStr
  }
}
